<template>
  <a-modal width="600px" v-model="isShow" :closable="false" :title="title" :afterClose="handleCancel" :maskClosable="false">
    <a-form-model ref="formDom" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
      <a-form-model-item label="ip地址" prop="ip_address">
        <a-input v-model.trim="form.ip_address" placeholder="请输入" style="width: 90%;"/>
      </a-form-model-item>
      <a-form-model-item label="使用平台">
        <a-select v-model="form.line_id" allowClear show-search option-filter-prop="children" mode="multiple" placeholder="不选开放平台，即为开放所有" style="width: 90%">
          <a-select-option v-for="item in platformList" :key="item.id" :value="item.id" style="width: 100%;">{{ item.org }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="有效期" prop="expiration_date">
        <v-range-picker v-model="form.expiration_date" @change="onCreateAtChange" :placeholder="['开始时间', '结束时间']" style="width: 90%;" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-textarea placeholder="请输入" v-model.trim="form.remark" :max-length="200" allow-clear style="width: 90%;" />
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button key="back" @click="handleCancel"> 取 消 </a-button>
      <a-button key="submit" type="primary" :loading="btnloading" @click="handleSubmit"> 提 交 </a-button>
    </template>
  </a-modal>
</template>
<script>
import { reactive, toRefs, getCurrentInstance, defineComponent, onMounted, watch, computed } from '@vue/composition-api'
import { form, rules } from './business/filialeList'
import dialog from '@/composables/dialog'
import compuedFun from './business/index'
import api from '@/api/'
import moment from 'moment'
const title = {
  Add: '新增',
  Edit: '编辑'
}

export default defineComponent({
  mixins: [dialog],
  props: {
    platformList: {
      type: [Object, Array],
      default() {
        return {}
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: {}
    }
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const state = reactive({
      rules,
      title: title.Add,
      btnloading: false,
      principalList: [], // 负责人
      form: { ...form }
    })

    watch(
      () => _this.params,
      async () => {
        state.form = JSON.parse(JSON.stringify({ ..._this.params }))
        _this.$set(state.form, 'expiration_date', [Number(state.form.expiration_start_date), Number(state.form.expiration_end_date)])
        const responsible = state.form.responsible_name + '(' + state.form.responsible_number + ')'
        _this.$set(state.form, 'responsible', responsible)
      }
    )

    watch(
      () => _this.isEdit,
      async () => {
        state.title = _this.isEdit ? title.Edit : title.Add
      }
    )
    const methods = {
        onCreateAtChange(date, dateString) {
        if (dateString[0] === '') {
          _this.form.expiration_date = []
           _this.$set(state.form, 'expiration_date', [])
          return
        }
         _this.$set(state.form, 'expiration_date', [
           Number(moment(dateString[0]).startOf('day').format('X')),
           Number(moment(dateString[1]).endOf('day').format('X')),
        ])
        // _this.form.expiration_date = [
        //    Number(moment(dateString[0]).startOf('day').format('X')),
        //    Number(moment(dateString[1]).endOf('day').format('X')),
        // ]
      },
      handleSubmit() {
        state.btnloading = true
        _this.$refs.formDom.validate(async valid => {
          let res = null
          const data = { ...state.form }
          const [start_date, end_date] = data.expiration_date
            data.expiration_start_date = start_date
            data.expiration_end_date = end_date
            delete data.expiration_date
          if (valid) {
            if (_this.isEdit) {
              res = await api.ipAddressWhiteUpdate(data)
            } else {
              res = await api.ipAddressWhiteCreate(data)
            }
            if (_this.$validate(res)) {
              this.$message.success(_this.isEdit ? '编辑成功~' : '添加成功~')
              _this.isShow = false
              state.btnloading = false
              _this.$emit('handleOver')
              _this.$refs.formDom.resetFields()
            } else {
              state.btnloading = false
            }
          } else {
            this.$message.warning('请检查信息是否填写完成')
            state.btnloading = false
          }
        })
      },
      handleCancel() {
        _this.$refs.formDom.resetFields()
        _this.form.line_id = []
        _this.isShow = false
      },
      handleCancelCategory() {
        if (!_this.isEdit) {
          _this.form.typeids = []
          _this.form.sync_xml_loc = ''
        }
      }
    }
    return {
      ...toRefs(state),
      ...compuedFun(),
      ...methods
    }
  }
})
</script>
